import React from "react";
import * as styles from "./fullWidthImage.module.scss"
import { GatsbyImage } from "gatsby-plugin-image"

const FullWidthImage = ({ data }) => {

    const imageGallery = data.images.map((image, i) => {
        return (
            <GatsbyImage 
                image={image.gatsbyImage} 
                alt={image.title} 
                className={styles.fullWidthImage__image}
                key={i}
            />
        )
    })

    return (
        <div
            className={styles.fullWidthImage}
            style={{
                paddingTop: `${data.paddingTop}rem`,
                paddingBottom: `${data.paddingBottom}rem`
            }}
        >
            <div className="container">
                <div className="row">
                    <div className="col-lg-10 offset-lg-1">
                        <div className={styles.fullWidthImage__container}>
                            {imageGallery}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FullWidthImage